"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
function clamp(min, max, value) {
    return value <= min ? min : value >= max ? max : value;
}
exports.clamp = clamp;
